import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Particles from '@tsparticles/react';
import daoHoa from 'assets/themes/tet/hoa-dao.png';
import daoLeft from 'assets/themes/tet/dao-left.png';
import daoRight from 'assets/themes/tet/dao-right.png';
import { isDashboardRoute } from './isDashboardRoute';

const EFFECT_Z_INDEX = 11;

export default function TetEffect() {
    const { pathname } = useLocation();
    const showPetals = isDashboardRoute(pathname);

    const options = useMemo(
        () => ({
            fullScreen: {
                enable: true,
                zIndex: EFFECT_Z_INDEX,
            },
            background: {
                color: { value: 'transparent' },
            },
            particles: {
                number: { value: 15 },
                shape: {
                    type: 'image',
                    options: {
                        image: [
                            {
                                src: daoHoa,
                                width: 32,
                                height: 32,
                            },
                        ],
                    },
                },
                move: {
                    enable: true,
                    speed: 0.8,
                    direction: 'bottom',
                    // drift: 5
                },
                size: {
                    value: { min: 8, max: 12 },
                },
                opacity: {
                    value: 0.85,
                },
            },
        }),
        [],
    );

    return (
        <div className="theme-effects-layer" aria-hidden>
            {showPetals ? <Particles id="tet-particles" options={options} /> : null}
            {/* <img src={daoLeft} className="tet-branch-left" alt="" /> */}
            <img src={daoRight} className="tet-branch-right" alt="" />
        </div>
    );
}
